import { gql } from 'react-apollo';

export const createEvangelist = gql`
  mutation createEvangelist($input: CreateEvangelistInput!) {
    createEvangelist(input: $input) {
      evangelist: evangelist {
        email
        name
        photo {
          small
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/mutations/createEvangelist.js